import Vue from "vue";

const modulo_pedidos = {
	strict: false,

  state:{
    pedidos:[],
	lineas:[],
	metodos_pago:[],
	current:0
  },

	getters: {
		getpedidos: state => state.pedidos,
		getlineaspedido: state => state.lineas,
		getmetodopedido: state => state.metodos_pago,

	},

	mutations: {
		get_pedidos: (state, pedidos) => {
			state.pedidos = pedidos;
			//state.page = 2;
		},
		get_lineas: (state, lineas) => {
			state.lineas = lineas;
			//state.page = 2;
		},
		get_metodos: (state, metodos) => {
			state.metodos_pago = metodos;
			//state.page = 2;
		},
	
	},

	actions: {
		getPedidos: (context, vm) => {
			axios.get('api/get-pedidos').then(res => {        
				context.commit('get_pedidos', res.data.Pedidos)
			}, res => {
				
			})
		},
		getLineas: (context, vm) => {
			axios.get(`api/get-pedido/${vm}`).then(
                (res) => {
					context.commit('get_lineas', res.data.lineas)
					context.commit('get_metodos', res.data.metodos_pago)

                },
                (res) => {}
            );
		},
	
		
	}
}

export default modulo_pedidos;
